import Cookies from 'js-cookie'

const TokenKey = 'CoriMall-GB-Token'
const UserIdKey = 'CoriMall-GB-UserId'
const SupplierIdKey = 'CoriMall-GB-SupplierId'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserId() {
  return Cookies.get(UserIdKey)
}

export function setUserId(userId) {
  return Cookies.set(UserIdKey, userId)
}

export function removeUserId() {
  return Cookies.remove(UserIdKey)
}

export function getSupplierId() {
  return Cookies.get(SupplierIdKey)
}

export function setSupplierId(supplierId) {
  return Cookies.set(SupplierIdKey, supplierId)
}

export function removeSupplierId() {
  return Cookies.remove(SupplierIdKey)
}
